import React from 'react';
const { formatDate, formatarCpfCnpj, formatarTelefone } = require('../../../../../utils/format');
import { MODO_IMPRESSAO, TIPO_DOCUMENTO } from '~/constants';

const OrcamentoIdentificationSection = ({ documento, title, tipoDocumento, modoImpressao }) => {
  const orcamento_situacao = [
    'Fechado',
    'Aberto',
    'Parc. Fechado',
  ];
  const pedido_situacao = [
    "Fechado",
    "Aberto",
    "Parcialmente Faturado",
    "Bloqueado",
    "Rejeitado Credito",
    "Rejeitado Estoque",
    "Rejeitado Por Regra Comercial de Negócio",
    "Rejeitado Por Regra Comercial de Desconto"
  ];
  const doc_saida_situacao = [
    "Nao Se Aplica",
    "Nao Transmitido",
    "Documento Eletronico Transmitido",
    "Aguardando Transmissao",
    "Em Processamento",
    "Denegado",
    "Em Andamento",
    "Erro Comunicacao SEFAZ",
    "Inutilizada",
  ]

  const impressaoA4 = modoImpressao === MODO_IMPRESSAO.A4;

  const getAddress = () => {
    if (documento?.entregaLogradouro) {
      return `${documento.entregaLogradouro}
      ${documento.entregaLogradouroNumero ? `, N° ${documento.entregaLogradouroNumero}` : ''}
      ${documento.entregaBairro ? `, ${documento.entregaBairro}` : ''}`;
    } else if (documento?.enderecoLogradouro) {
      return `${documento.enderecoLogradouro}
      ${documento.enderecoLogradouroNumero ? `, N° ${documento.enderecoLogradouroNumero}` : ''}
      ${documento.enderecoBairro ? `, ${documento.enderecoBairro}` : ''}`;
    }
    return 'Não informado';
  };

  return (
    <div className={`scrollable`} style={{ border: '1px solid black', borderBottom: 'none', overflowX: 'auto', padding: 'var(--spacing-size)' }}>
      <h2
        style={{ fontSize: 'var(--main-title-text-size)', textAlign: 'center' }}
      >
        {title} - {documento?.serie || documento?.documentoSerie}/
        {documento?.numero || documento?.documentoNumero}
      </h2>
      <h2
        style={{ fontSize: 'var(--section-title-text-size)', textAlign: 'center', fontWeight: '500', color: '#acacac', paddingBottom: 'var(--half-spacing-size)' }}
      >
        {tipoDocumento==TIPO_DOCUMENTO.DOCUMENTOSAIDA ? 'DOCUMENTO NÃO FISCAL' : ''}
      </h2>
      <div style={{ fontWeight: '700', fontSize: 'var(--section-title-text-size)', paddingBottom: 'var(--half-spacing-size)' }}>
        IDENTIFICAÇÃO
      </div>
      <div
        style={{
          fontSize: 'var(--regular-text-size)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: 'var(--horizontal-item-grid-spacing)',
        }}
      >
        <div style={{display: 'flex', flexGrow: 0, minWidth: 0}}>
          <div
            style={{
              fontSize: 'var(--regular-text-size)',
              display: 'grid',
              gridTemplateColumns: 'auto 1fr',
              rowGap: 'var(--vertical-item-grid-spacing)',
              columnGap: 'var(--horizontal-item-grid-spacing)',
              alignItems: 'baseline',
            }}
          >
            <strong>Cliente:</strong>
            <span style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>{documento?.clienteNome || 'Não informado'}</span>
            <strong>CPF/CNPJ:</strong>
            <span style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
              {formatarCpfCnpj(
                documento?.intCliente?.pfCpf ||
                  documento?.intCliente?.pjCnpj ||
                  documento?.clienteCpfCnpj
              ) || 'Não informado'}
            </span>
            <strong>Telefone:</strong>
            <span style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
              {formatarTelefone(documento?.intCliente?.telefone) ||
                formatarTelefone(documento?.clienteTelefone) ||
                'Não informado'}
            </span>
            {impressaoA4 && (
              <>
                <strong>Cidade:</strong>
                <span style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                  {(documento?.entregaIntCidade?.cidade
                    ? `${documento.entregaIntCidade.cidade}${
                        documento.entregaIntCidade.uf
                          ? `-${documento.entregaIntCidade.uf}`
                          : ''
                      } CEP: ${documento?.entregaCep}`
                    : '') ||
                    (documento?.enderecoIntCidade?.cidade
                      ? `${documento.enderecoIntCidade.cidade}${
                          documento.enderecoIntCidade.uf
                            ? `-${documento.enderecoIntCidade.uf}`
                            : ''
                        } CEP: ${documento?.enderecoCep}`
                      : '') ||
                    'Não informado'}
                </span>
                <strong>Logradouro:</strong>
                <span style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>{getAddress() || '---'}</span>
                <strong>Referência:</strong>
                <span style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                  {documento?.entregaComplemento ||
                    documento?.enderecoComplemento ||
                    'Não informado'}
                </span>
              </>
            )}
          </div>
        </div>
        {!impressaoA4 && (
          <div style={{display: 'flex', flexGrow: 0, minWidth: 0}}>
            <div
              style={{
                fontSize: 'var(--regular-text-size)',
                display: 'grid',
                gridTemplateColumns: 'auto 1fr',
                rowGap: 'var(--vertical-item-grid-spacing)',
                columnGap: 'var(--horizontal-item-grid-spacing)',
                alignItems: 'baseline',
              }}
            >
              <strong>Cidade:</strong>
              <span style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                {(documento?.entregaIntCidade?.cidade
                  ? `${documento.entregaIntCidade.cidade}${
                      documento.entregaIntCidade.uf
                        ? `-${documento.entregaIntCidade.uf}`
                        : ''
                    } CEP: ${documento?.entregaCep}`
                  : '') ||
                  (documento?.enderecoIntCidade?.cidade
                    ? `${documento.enderecoIntCidade.cidade}${
                        documento.enderecoIntCidade.uf
                          ? `-${documento.enderecoIntCidade.uf}`
                          : ''
                      } CEP: ${documento?.enderecoCep}`
                    : '') ||
                  'Não informado'}
              </span>
              <strong>Logradouro:</strong>
              <span style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>{getAddress() || '---'}</span>
              <strong>Referência:</strong>
              <span style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                {documento?.entregaComplemento ||
                  documento?.enderecoComplemento ||
                  'Não informado'}
              </span>
            </div>
          </div>  
        )}
        <div style={{display: 'flex', flexGrow: 0, minWidth: 0}}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'auto 1fr',
              rowGap: 'var(--vertical-item-grid-spacing)',
              columnGap: 'var(--horizontal-item-grid-spacing)',
              alignItems: 'baseline',
              textAlign: 'left',
            }}
          >
            <strong>Emissão:</strong>
            <span>{formatDate(documento?.logCriacao) || '---'}</span>
            <strong>Situação:</strong>
            {tipoDocumento === TIPO_DOCUMENTO.ORCAMENTO && (
              <span>{orcamento_situacao[documento?.situacao] || '---'}</span>
            )}
            {tipoDocumento === TIPO_DOCUMENTO.PEDIDO && (
              <span>{pedido_situacao[documento?.situacao] || '---'}</span>
            )}
            {tipoDocumento === TIPO_DOCUMENTO.DOCUMENTOSAIDA && (
              <span>{doc_saida_situacao[documento?.documentoTransmissao] || '---'}</span>
            )}
            <strong>Vendedor:</strong>
            <span>{documento?.fatVendedor?.nome || '---'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrcamentoIdentificationSection;
